import {styled} from "@mui/system";
import {Box} from "@mui/material";
import backgroundUrl from "../../assets/blume_bg1.jpg";

export const BackgroundWrapper = styled(Box)({
    height: '100%',/* Center the background image */
    display: 'flex'

})

export const Header = styled('h1')({
    color: "var(--brand-default-color)",
    fontSize: '40px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '64px',
    letterSpacing: '-0.25px',
    textAlign: 'center',
    margin: '0 0 0 0',
    fontFamily: "Manrope, sans-serif",
})

export const Body = styled('h4')({
    fontSize: '14px',
    lineHeight: '19px',
    letterSpacing: '0.5px',
    color: '#000',
    textAlign: 'center',
    fontWeight: 400,
    fontFamily: "Manrope, sans-serif",
    margin: '0 0 24px 0',
})

export const ContentWrapper = styled(Box)({
    margin: '0 auto',
    width: '560px',
})